export default __webpack_public_path__ + "static/media/header-texture.46b0ae6f.jpg";